import BasicDetailsRepository from "@adapters/features/BasicProfile/Repository/BasicProfile";
import { accountDetails } from "../../../../../../mainDi/webDi";
export default (function (http) {
    return {
        basicProfile: new BasicDetailsRepository(http, accountDetails),
    };
});
